import { filter_day, filter_month, filter_week } from '../../../../../views/marketing/overview/PeriodFilter';

export default {
  filters: {
    [filter_day]: 'Giorno',
    [filter_week]: 'Settimana',
    [filter_month]: 'Mese',
    null: 'Totale',
  },
};
